// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__wzZSZ","spin":"Loader_spin__c7XLw"};